import React from 'react';
import { RouteEnum } from 'pro/config/routers';
import { PureBreadcrumbsItem } from '@base/lib/PureBreadcrumbs';
import Script from 'next/script';
import { useTrans } from 'base/utils/i18n';

type BreadcrumbSchemaProps = {
  id: string;
  items: PureBreadcrumbsItem[];
};

type Breadcrumb = {
  "@type": string;
  position: number;
  item: {
    name: string;
    "@id": string;
    "@type": string;
  }
};

const BreadcrumbSchema: React.FC<BreadcrumbSchemaProps> = ({ id, items }) => {
    const { t } = useTrans();
    const list: Breadcrumb[] = [];
    let position = 1;
    list.push({
        "@type": "ListItem",
        position: position++,
        item: {
          name: t('web_page_link_home'),
          "@id": RouteEnum.SHOP,
          "@type": "WebPage" // WebSite for /
        }
    });
    for (const item of items) {
      list.push({
        "@type": "ListItem",
        position: position++,
        item: {
          name: item.name,
          "@id": item.url || '',
          "@type": "WebPage"
        }
      });
    }
    const schema = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": list,
    };

    return (
        <Script
            id={`prod-breadcrumbs-schema-${id}`}
            type="application/ld+json"
            strategy="beforeInteractive"
            dangerouslySetInnerHTML={{
                __html: JSON.stringify(schema)
            }}
        />
    )
};

export default BreadcrumbSchema;
